import { query, getToken, getApiUrl } from "@sinao/core-js";
import {convertNumberToString, convertStringToNumber} from "../mixins/filters";
import i18n from "@/i18n";

// requests abort variables
let abortControllerProducts = null;
let requestIdProducts = 0;

const billing = {
	state: () => ({
		dynamicColspan: 0,
		headers: {
			line_number: {
				value: i18n.t("N°"),
				placeholder: i18n.t("N°"),
				enabled: false,
				width: "40px",
				translationKey: "N°"
			},
            reference: {
                value: i18n.t("Référence"),
                placeholder: i18n.t("Référence"),
                enabled: false,
                translationKey:"Référence"
            },
			designation: {
				value: i18n.t("Désignation"),
				placeholder: i18n.t("Désignation"),
				width: "50%",
				enabled: false,
				translationKey:"Désignation"
			},
			quantity: {
				value: i18n.t("Quantité"),
				placeholder: i18n.t("Quantité"),
				enabled: false,
				translationKey: "Quantité"
			},
			quantity_name: {
				value: i18n.t("Unité"),
				placeholder: i18n.t("Unité"),
				enabled: false,
				translationKey: "Unité"
			},
			info_total_quantity: {
				value: i18n.t("Qt. Total"),
				placeholder: "Qt. Total",
				enabled: false,
				translationKey: "Qt. Total"
			},
			amount: {
				value: i18n.t("P.U HT"),
				placeholder: i18n.t("P.U HT"),
				enabled: false,
				translationKey: "P.U HT"
			},
			progress: {
				value: i18n.t("Avancement"),
				placeholder: i18n.t("Avancement"),
				enabled: false,
				translationKey: "Avancement"
			},
			amount_with_taxes: {
				value: i18n.t("P.U TTC"),
				placeholder: i18n.t("P.U TTC"),
				enabled: false,
				translationKey: "P.U TTC"
			},
			discount: {
				value: i18n.t("Remise HT"),
				placeholder: i18n.t("Remise HT"),
				enabled: false,
				translationKey: "Remise HT"
			},
			subtotal: {
				value: i18n.t("Total HT"),
				placeholder: i18n.t("Total HT"),
				enabled: false,
				translationKey: "Total HT"
			},
			due: {
				value: i18n.t("Total TTC"),
				placeholder: i18n.t("Total TTC"),
				enabled: false,
				translationKey: "Total TTC"
			},
			vat_percent: {
				value: i18n.t("TVA %"),
				placeholder: i18n.t("TVA %"),
				enabled: false,
				translationKey: "Total TTC"
			}
		},
		table: {
			sections: [],
			totals: {
				exclTax: 0,
				vat: 0,
				inclTax: 0
			}
		},
		accounts: []
	}),
	mutations: {
		table(state, payload) {
			state.table = payload;
		},
		headers(state, payload) {
			state.headers = payload;
		},
		enableHeaderByKey(state, payload) {
			if (state.headers[payload] && state.headers[payload]?.enabled !== true) {
				state.headers[payload].enabled = true;
				state.dynamicColspan += 1;
			}
		},
		renameHeaderByKey(state, { key, value }) {
			// must keep hand if changed value
			if (state.headers[key]) {
				state.headers[key].value = i18n.t(state.headers[key].translationKey) === i18n.t(value) ? i18n.t(value) : value; // i18n.t(value) ;
			}
		},
		updateHeadersByLang(state, previousLang) {
			Object.keys(state.headers).forEach(key => {
				//state.headers[key].placeholder = i18n.t(state.headers[key].translationKey);
				if (i18n.t(state.headers[key].translationKey, previousLang) === state.headers[key].value) {
					state.headers[key].value = i18n.t(state.headers[key].translationKey);
				}
			});
		},
		enableDefaultHeaders(state) {
			const headers = ["designation", "quantity", "amount", "subtotal"];

			headers.forEach(key => {
				if (state.headers[key] && state.headers[key]?.enabled !== true) {
					state.headers[key].enabled = true;
					state.dynamicColspan += 1;
				}
			});
		},
		disableHeaderByKey(state, payload) {
			if (state.headers[payload] && state.headers[payload]?.enabled === true) {
				state.headers[payload].enabled = false;
				state.dynamicColspan -= 1;

			}
		},
		dynamicColspan(state, payload) {
			state.dynamicColspan = payload;
		},
		accounts(state, payload) {
			state.accounts = payload;
		},
		updateNumbersByLang(state, previousLang) {
			const _table = Object.assign({}, state.table);
			for (let s1= 0; s1 < _table.sections.length; s1++) {
				for (let s2= 0; s2 < _table.sections[s1].length; s2++) {
					if (_table.sections[s1][s2].component === "entry") {
						_table.sections[s1][s2].data.amount = convertNumberToString(convertStringToNumber(_table.sections[s1][s2].data.amount, null, previousLang));
						_table.sections[s1][s2].data.amountWithTaxes = convertNumberToString(convertStringToNumber(_table.sections[s1][s2].data.amountWithTaxes, null, previousLang));
						_table.sections[s1][s2].data.discount.value = convertNumberToString(convertStringToNumber(_table.sections[s1][s2].data.discount.value, null, previousLang));
						_table.sections[s1][s2].data.progress= convertNumberToString(convertStringToNumber(_table.sections[s1][s2].data.progress, null, previousLang));
						_table.sections[s1][s2].data.quantity= convertNumberToString(convertStringToNumber(_table.sections[s1][s2].data.quantity, null, previousLang));
						_table.sections[s1][s2].data.totalExclTax= convertNumberToString(convertStringToNumber(_table.sections[s1][s2].data.totalExclTax, null, previousLang));
						_table.sections[s1][s2].data.totalInclTax= convertNumberToString(convertStringToNumber(_table.sections[s1][s2].data.totalInclTax, null, previousLang));
						_table.sections[s1][s2].data.totalQuantity= convertNumberToString(convertStringToNumber(_table.sections[s1][s2].data.totalQuantity, null, previousLang));
						_table.sections[s1][s2].data.vatAmount= convertNumberToString(convertStringToNumber(_table.sections[s1][s2].data.vatAmount, null, previousLang));
						_table.sections[s1][s2].data.vatPercentage= convertNumberToString(convertStringToNumber(_table.sections[s1][s2].data.vatPercentage, null, previousLang));
					}
				}
			}

			state.table = Object.assign({}, _table);
		},
		updateMentionsByLang(state, lang) {
		}
	},
	getters: {
		enabledHeaders: state => {
			const enabled = {};

			for (const key of Object.keys(state.headers)) {
				if (state.headers[key].enabled === true) {
					enabled[key] = state.headers[key];
				}
			}

			return enabled;
		},
		enabledHeadersValues: (state, getters) => {
			let values = {};

			Object.keys(getters.enabledHeaders).forEach(key => {
				values = {
					...values,
					[key]: getters.enabledHeaders[key].value
				};
			});

			return values;
		},
		headerByKey: state => payload => state.headers[payload],
		searchAllRows: state => componentType => {
			const rows = [];

			Object.values(state.table.sections).forEach(section => {
				for (const row of section) {
					if (row.component === componentType) {
						rows.push(row);
					}
				}
			});

			return rows;
		},
		// Main totals
		totals(state) {
			const totals = {
				table: {
					exclTax: 0,
					vat: 0,
					inclTax: 0
				},
				sections: []
			};

			state.table.sections.forEach((section, index) => {
				totals.sections[index] = {
					exclTax: 0,
					vat: 0,
					inclTax: 0
				};

				Object.values(section).forEach(row => {
					const { component, data } = row;

					if (component === "entry" && data) {
						// NOTE : DO NOT MODIFY, ALL THE CALCULATIONS NEED TO GO INSIDE THE COMPONENTS

						totals.table.exclTax += convertStringToNumber(data.totalExclTax);
						totals.table.inclTax += convertStringToNumber(data.totalInclTax);
						totals.table.vat += convertStringToNumber(data.vatAmount); // Coupon value?

						totals.sections[index].exclTax += convertStringToNumber(data.totalExclTax);
						totals.sections[index].inclTax += convertStringToNumber(data.totalInclTax);
						totals.sections[index].vat += convertStringToNumber(data.vatAmount);
					}
				});
			});

			return totals;
		},
		numbered_sections(state) {
			let row_number = 0;
			let section_number = 0;
			return state.table.sections.map(section => {
				section_number ++;
				section.forEach(section_row => {
					// we don't put the line_number in component.data as we don't keep in a specific field in DB
					if (section_row.component === "section") {
						section_row.line_number = `${section_number}`;
						row_number = 0; // reset row_number
					} else if (section_row.component === "entry") {
						row_number++;
						section_row.line_number = `${section_number}.${row_number}`;
					} else {
						section_row.line_number = '';
					}
				});
				return section;
			});
		}
	},
	actions: {
		async products({ rootState }, { searchValue }) {
			// increment requestIdRelationships and set currentRequestID
			const currentRequestId = ++requestIdProducts;

			// Cancel previous request if exists
			if (abortControllerProducts) {
				abortControllerProducts.abort();
			}

			// create a new local controller and assign it to abortControllerRelationships
			const controller = new AbortController();
			abortControllerProducts = controller;

			try {
				const apiUrl = await getApiUrl(); // return https://api.sinao.test/v1
				const params = {
					search: searchValue,
					limit: rootState.app.MAX_SUGGESTIONS,
					'expand[0]': 'category',
				};

				// eslint-disable-next-line compat/compat
				const urlSearchParams = new URLSearchParams(params);
				const url = `${apiUrl}/apps/${rootState.app.id}/products?` + urlSearchParams;

				// eslint-disable-next-line compat/compat
				const response = await fetch(url, {
					headers: {
						"Content-Type": "application/json",
						Authorization: `Bearer ${getToken()}`
					},
					method: "GET",
					signal: controller.signal
				});
				const { data } = await response.json();
				// if a newest request is processing, ignore this one
				if (currentRequestId !== requestIdProducts) {
					return;
				}
				return data ?? [];
			} catch (error) {
				if (error.name === "AbortError") {
					return;
				}
				throw new Error(error);
			} finally {
				// reset abortControllerRelationships only if is the current controller
				if (abortControllerProducts === controller) {
					abortControllerProducts = null;
				}
			}
		},
		async accounts({ commit }, appId) {
			try {
				const response = await query({
					operationId: "app.accounting.accounts.list",
					params: {
						appId,
						"filters[0][name]": "is_sales",
						"filters[0][comparator]": "=",
						"filters[0][value]": 1
					}
				});

				commit("accounts", response.data);

				return response.data;
			} catch (error) {
				throw new Error(error);
			}
		}
	}
};

export default billing;
